import type { LevelDefinition } from '../world/LevelDefinition';

const surfaces = {
  floor: { enabled: true, magnetic: true },
  ceiling: { enabled: true, magnetic: true },
  left: { enabled: true, magnetic: true },
  right: { enabled: true, magnetic: true },
  front: { enabled: true, magnetic: true },
  back: { enabled: true, magnetic: true },
};

/**
 * Gauntlet (lethal): one tall shaft with the drones spread up the walls and
 * across the ceiling. It is the magnetic-paws showcase — the upper drones are
 * only reachable by walking up a wall — and the lethal tier's eight-shot bursts
 * are tight and unpredictable, so the dodge has to be reactive rather than
 * remembered.
 */
export const GAUNTLET: LevelDefinition = {
  id: 'gauntlet',
  name: 'Gauntlet',
  difficulty: 'lethal',
  size: [18, 22, 18],
  surfaces,
  spawn: { surface: 'floor', position: [0, 0, 7], facing: Math.PI },
  targets: [
    { type: 'drone', surface: 'floor', position: [0, 0, -6] },
    { type: 'drone', surface: 'floor', position: [3.5, 0, 6] },
    { type: 'drone', surface: 'left', position: [-9, 5, -3] },
    { type: 'drone', surface: 'right', position: [9, 5, 3] },
    { type: 'drone', surface: 'left', position: [-9, 12, 4], magnetic: true },
    { type: 'drone', surface: 'right', position: [9, 16, -4], magnetic: true },
    { type: 'drone', surface: 'ceiling', position: [0, 22, 0] },
    { type: 'drone', surface: 'ceiling', position: [5, 22, 5] },
    { type: 'drone', surface: 'front', position: [0, 18, -9] },
  ],
  obstacles: [
    // A climbable stack on the floor, and pillars that break the shaft into
    // lanes so a burst is not three drones firing down one open column.
    { type: 'box', kind: 'crate', position: [-3, 0.7, -2], size: [1.4, 1.4, 1.4] },
    { type: 'box', kind: 'crate', position: [-3, 2.1, -2], size: [1.4, 1.4, 1.4] },
    { type: 'box', kind: 'crate', position: [3, 0.7, 2], size: [1.4, 1.4, 1.4] },
    { type: 'box', kind: 'crate', position: [3, 2.1, 2], size: [1.4, 1.4, 1.4] },
    { type: 'box', kind: 'pillar', position: [-5.5, 11, 0], size: [1.6, 22, 1.6] },
    { type: 'box', kind: 'pillar', position: [5.5, 11, 0], size: [1.6, 22, 1.6] },
    { type: 'box', kind: 'console', position: [0, 0.5, 3], size: [2.4, 1, 0.9] },
    { type: 'box', kind: 'console', position: [0, 0.5, -3], size: [2.4, 1, 0.9] },
  ],
  style: {
    wallColor: 0x2b2733,
    floorColor: 0x17151c,
    ceilingColor: 0xc2b9d6,
    pathColor: 0xff6a8a,
    path: [
      { from: [0, 8], to: [0, -8], width: 2.4 },
      { from: [-8, 0], to: [8, 0], width: 1.6 },
    ],
    ceilingLights: [
      { position: [0, 21.9, 0], size: [2.4, 0.08, 1.4] },
      { position: [0, 10.9, 0], size: [2.4, 0.08, 1.4] },
      { position: [0, 3.9, 0], size: [2.4, 0.08, 1.4] },
      { position: [-6, 15.9, 6], size: [2, 0.08, 1.2] },
      { position: [6, 15.9, -6], size: [2, 0.08, 1.2] },
    ],
  },
  seed: 5171,
};
